export default "__VITE_ASSET__W7NSnuC0__";